import React, { forwardRef } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/confetti.css";
import { IconCalendarLight } from "../../../icon/icons";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

const FlatpickrInput = forwardRef(
  (
    {
      value = "",
      onChange = () => {},
      placeholder,
      mode = "single",
      format = "Y-m-d",
    },
    ref
  ) => {
    return (
      <div className="date-input-inner">
        <Flatpickr
          className=""
          value={value}
          onChange={onChange}
          onClick={(e) => e.stopPropagation()}
          options={{
            dateFormat: format,
            disableMobile: false,
            disable: [], // Add disabled dates here if needed
            mode: mode,
            // Enables date range selection
            plugins:
              format === "Y-m"
                ? [
                    new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "Y-m",
                      altFormat: "F Y",
                    }),
                  ]
                : [],
          }}
          placeholder={placeholder || ""}
          ref={ref}
        />
        <span onClick={() => ref?.current?.flatpickr.open()}>
          <IconCalendarLight />
        </span>
      </div>
    );
  }
);

export default FlatpickrInput;
